import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  getItem,
  setBolDate,
  setMobileFilterDrawerOpen,
  setSelectedAffiliate,
} from '../../store/rackWaitTimesSlice';
import FilterDrawer from './FilterDrawer';

const mapState = R.applySpec({
  bolDate: getItem('bolDate'),
  mobileFilterDrawerOpen: getItem('mobileFilterDrawerOpen'),
  selectedAffiliate: getItem('selectedAffiliate'),
});

const mapDispatch = {
  setBolDate,
  setMobileFilterDrawerOpen,
  setSelectedAffiliate,
};

export default connect(mapState, mapDispatch)(FilterDrawer);
